module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Title_Page"
  }, [_c('h2', {
    staticClass: "chaptitle2"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Contents#ch7",
      "id": "rch7"
    }
  }, [_c('b', [_vm._v("Accidentally Excellent")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub1"
  }, [_c('b', [_vm._v("Are you accident-prone? Don’t worry, it could end up making the world a better place.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p27.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_vm._v("FIRST GLASS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("One day in 1903, French chemist Edouard Benedictus was working in his lab when he accidentally knocked an empty glass flask off his workbench. When he picked it up, he noticed something strange: The glass had shattered into many pieces, but they remained stuck together in the shape of the bottle. Upon further investigation, he found that the flask had been filled with collodion, a syrupy chemical solution that, when evaporated, leaves a clear film. The film had coated the inside of the glass and held the pieces together. (Collodion, though quite toxic, was used in those days to seal cuts after surgery.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Although Benedictus thought this was interesting, he went back to his regular work. A few days later, he read a newspaper story about a woman who had been killed by a broken windshield in a car accident. Benedictus rushed to his lab. By the next night he had invented the world’s first safety glass, which can be found in virtually every car in the world today.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_vm._v("SUPERPRINTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("In 1977 Fuseo Matsumur, an examiner in a Japanese crime laboratory, was placing hairs on microscope slides during a murder investigation. Suddenly he noticed his own fingerprints developing on the glass slides. He mentioned it to his partner, Masato Soba, who asked what he had used to affix the hairs to the slides. Fuseo said he was using "), _c('i', [_vm._v("cyanoacrylate ester")]), _vm._v(", better known as super glue. Soba began experimenting and soon discovered that super glue vapors are absorbed by the perspiration and oils left by fingerprints, turning them white. The use of cyanoacrylate fumes to reveal latent (hard-to-find) fingerprints became one of the biggest breakthroughs in the history of fingerprint forensics.")])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p28.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Silly Putty advertisement from 1950")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_vm._v("THAT’S JUST SILLY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("In 1943 General Electric engineer James Wright was attempting to create artificial rubber, desperately needed for the war effort because the Japanese had invaded rubber-producing areas in Southeast Asia. In one "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("experiment, Wright tried mixing boric acid with silicon oil. The substance that resulted was amazingly bouncy and could be stretched great distances. Those weren’t very useful qualities, but the substance sure was fun. Wright’s family members and friends—and even friends of friends—played with the “nutty putty” for years, until someone finally thought to market it. By the mid-1950s, Silly Putty was one of the most popular toys in the country.")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p29-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Alexander Fleming, busy making history in his lab")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_vm._v("THE NOBEL PRIZE FOR ACCIDENTS GOES TO…")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("…Alexander Fleming. In 1928 the Scottish scientist was experimenting with staphylococcus bacteria, the germs that cause staph infections, when he absentmindedly left some petri dishes exposed. Mold grew on the bacteria…and killed them. It was later determined to be penicillium mold, and Fleming named the active ingredient in the mold penicillin.")])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p29-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Culture flasks growing penicillin, 1943")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_vm._v("He wasn’t able to create a medicine from it, but 12 years later two other scientists at Oxford University, Howard Florey and Ernst Chain, succeeded. The accident-inspired invention came just in time: Penicillin was mass-produced during World War II and has saved millions of lives since then. In 1945 Fleming, Florey, and Chain were awarded the Nobel Prize in medicine.")])]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_c('b', [_vm._v("THE “COMMON COLD” CAN BE CAUSED BY MORE THAN 100 DIFFERENT VIRUSES.")])])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41326deb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/014_Chapter7.vue
// module id = 99
// module chunks = 0